import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon, Tooltip, Switch } from 'audamatic-ui';
import { IS_B2B } from '@config';
import Text from '@text';


import './styles.scss';

const ExpressDelivery = (props) => {
  const { showExpressOrder = false, updateValue } = props;

  const [toggleSwitch, setToggleSwitch] = useState(false);

  /*
   * Show this component only on:
   * monday - thursday
   * 12.00 - 16.00
   */
  const date = new Date();
  const day = date.getDay();
  const currentHour = date.getHours();
  let validTime = false;
  if ((day > 0 && day < 5) && (currentHour >= 12 && currentHour < 16)) {
    validTime = true;
  }

  const onClick = () => {
    const newValue = !toggleSwitch;
    setToggleSwitch(newValue);
    updateValue(newValue);
  };
  if (!IS_B2B || showExpressOrder === false || !validTime) {
    return null;
  }
  return (
    <div className="express-delivery">
      <Switch onChange={onClick} active={toggleSwitch} label={(
        <Text>expressorder.button.label</Text>
      )} />
      <div className="info">
        <Tooltip position="top" content={<Text>expressorder.button.tooltip</Text>}>
          <Icon name="InfoCircleSolid" size="sm"/>
        </Tooltip>
      </div>
    </div>
  );
};

ExpressDelivery.propTypes = {
  showExpressOrder: PropTypes.bool,
  updateValue: PropTypes.func,
};
export default ExpressDelivery;
